import React from 'react';

import { useAppSelector } from '../../components/hooks';
import { getActiveGridMode } from '../../store/selectors/layoutVisualOptionsSelectors';
import { GridVisual } from '../util/GridVisual';

export function LayoutGrid() {
  const gridMode = useAppSelector(getActiveGridMode);
  return gridMode === 'show' ? <GridVisual /> : null;
}
